import {
  createStyles,
  Theme,
  Typography,
  WithStyles,
  withStyles
} from '@material-ui/core';
import * as moment from 'moment';
import 'moment-timezone';
import * as React from 'react';
import Moment from 'react-moment';
import VerticalDivider from '../VerticalDivider/VerticalDivider';

const styles = (theme: Theme) =>
  // custom JSS
  createStyles({
    root: {
      fontWeight: 500,
      letterSpacing: 1.1,
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      fontSize: '1.25rem',
      margin: '0 0.5rem'
    },
    time: {
      color: theme.palette.text.primary,
      fontSize: '1.25rem',
      marginRight: '0.5rem'
    },
    timeZone: {
      opacity: 0.6,
      textAlign: 'center'
    }
  });

interface IClockProps extends WithStyles<typeof styles> {}
/*
The component will render the date and time in the local timezone. 
Format: Jan 9th 2019 2:45:53 IST
*/
class Clock extends React.Component<IClockProps> {
  public render() {
    const { classes } = this.props;
    return (
      <div className={classes.root}>
        <Moment interval={1000} format={'MMM Do YYYY z'} />
        <VerticalDivider style={{ height: '1.2rem', margin: '0 10px' }} />
        <Moment interval={1000} format={'HH:mm:ss'} className={classes.time} />
        <Typography style={{ fontSize: '1rem', marginTop: '4px' }}>
          {moment.tz(moment.tz.guess()).zoneAbbr()}
        </Typography>
      </div>
    );
  }
}
export default withStyles(styles)(Clock);
